import {
  Card,
  Col,
  Row,
  Paragraph,
  useTranslation,
  Divider,
} from '@packages/utils';
import { useTheme } from 'styled-components';
import { InplaceEditLabels } from 'components/Base/EditableFields/components/InplaceEditLabel';
import RemoveTATime from '../RemoveTATime';
import { TTATimeItemProps } from './TATimeItem.types';

const TATimeItem = ({ data, elcId }: TTATimeItemProps) => {
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.elcs.detail.meetings-tab.details.ta-time.add.form',
  });

  const theme = useTheme();
  const {
    duration,
    focus,
    meetingId,
    pillarName,
    taTimeId,
    createdBy,
    createdDate,
  } = data;

  return (
    <Card className="mb-3">
      <Row align="middle">
        <Col span={4}>
          <InplaceEditLabels label={t('pillar.LABEL')} />
          <Paragraph>{pillarName}</Paragraph>
        </Col>
        <Col span={8}>
          <InplaceEditLabels label={t('focus.LABEL')} />
          <Paragraph>{focus}</Paragraph>
        </Col>
        <Col span={2}>
          <InplaceEditLabels label={t('time.LABEL')} />
          <Paragraph>
            {duration} {t('time.MIN')}
          </Paragraph>
        </Col>
        <Col span={1}>
          <Divider
            type="vertical"
            color={theme.colorBlackMainBorder}
            height={32}
          />
        </Col>
        <Col span={8}>
          <Row gutter={[0, 0]} align="middle" wrap={false}>
            <Col>
              <Paragraph
                fontSize={theme.inPlaceEditFontSize}
                color={theme.colorBlackGrey60}
                fontWeight={theme.inPlaceEditFontWeightLabel}
                fontFamily={theme.inPlaceEditFontFamily}
                className="mb-0"
              >
                Entered by
              </Paragraph>
            </Col>
            <Col style={{ minWidth: 0 }}>
              <Paragraph
                ellipsis
                fontWeight={theme.fontWeightSemiBold}
                className="mb-0 ml-1"
              >
                {createdBy || ''}
              </Paragraph>
            </Col>
          </Row>
          {createdDate && (
            <Paragraph
              fontSize={theme.fontSizeMd}
              color={theme.colorBlackGrey60}
            >
              {createdDate}
            </Paragraph>
          )}
        </Col>
        <Col span={1}>
          <RemoveTATime
            taTimeId={taTimeId}
            elcId={elcId}
            meetingId={meetingId}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default TATimeItem;
